<template>
    <div class="authentication">
        <div class="content">
            <form>
                <div class="form_group">
                    <p style="padding-left: 150px; color: red;">{{status}}</p>
                    <p class="warn"><span v-show="errors.has('company')">{{errors.first('company')}}</span></p>
                    <label for="company">公司名称</label>
                    <input type="text" name="company" v-validate="'required'" v-model="param.auditName"/>
                    <p class="tips">提示：提交的企业名称与个人资料里面的企业名称不一致的话，企业认证将是未绑定的状态</p>
                </div>
                <div class="form_group">
                    <p class="warn"><span v-show="errors.has('type')">{{errors.first('type')}}</span></p>
                    <label for="type">证件类型</label>
                    <input type="radio" name="type" v-validate="'required'" v-model="param.auditImgType" value="3"/>组织机构代码证
                    <input type="radio" name="type" v-model="param.auditImgType" value="2"/>营业执照
                </div>
                <div class="form_group">
                    <p class="warn"><span v-show="errors.has('number')">{{errors.first('number')}}</span></p>
                    <label for="number">证件号码</label>
                    <input type="text" name="number" v-validate="'required'" v-model="param.auditImgCode"/>
                </div>
                <div class="form_group">
                    <p class="warn"><span v-show="!hasImg">点击上传</span></p>
                    <label for="choole">选择证件图片</label>
                    <file-upload
                            ref="upload"
                            :multiple="false"
                            v-model="files"
                            :extensions="options.extensions"
                            @input-file="inputFile"
                            @input-filter="inputFilter"
                            :post-action='options.url'
                    >
                        选择文件
                    </file-upload>
                    <button v-show="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true" type="button" class="start">开始上传</button>
                    <button v-show="$refs.upload && $refs.upload.active" @click.prevent="$refs.upload.active = false" type="button">停止上传</button>
                    <ul class="files">
                      <li v-for="file in files">{{file.name}}
                              <span v-if="file.error" style="color: red;">
                                  上传错误
                              </span>
                        <span v-if="file.success" style="color: #76D05E;">
                                  上传成功
                              </span>
                      </li>
                    </ul>
                    <p class="tips">单张图片大小不得超过1024k,宽高限制不超过2000px,允许上传的图片类型：jpg\gif\png</p>
                    <div v-for="file in files" class="thumb">
                        <img style="max-width: 700px" :src="file.blob" alt="缩略图">
                    </div>
                    <div class="thumb" v-if="param.auditImgOne && !upload">
                        <img style="max-width: 700px" :src="param.auditImgOne | imgPath" alt="缩略图">
                    </div>
                </div>
            </form>
        </div>
        <button class="submit" :disabled="!enableSubmit" type="button" @click="validateBeforeSubmit">提交认证</button>
    </div>
</template>
<script>
    import VueUploadComponent from 'vue-upload-component'
    let API = util.api(['CUSTOMERAPPLYIDENTIFY','CUSTOMERCHECKIDENTIFY','UPLOAD']);
    export default{
        components: {
            FileUpload: VueUploadComponent
        },
        data(){
            return{
                files:[],
                options:{
                    extensions:['jpg','gif','png'],
                    url: API.UPLOAD + ';jsessionid='
                },
                param:{
                    auditName:'',
                    auditImgType:'',
                    auditImgCode:'',
                    auditImgOne:'',
                    auditType:2,
                    id:''
                },
                upload:false,
                status:"",
                hasImg:true,
                enableSubmit: true
            }
        },
        methods:{
            inputFile: function (newFile, oldFile) {
                if (newFile && oldFile && !newFile.active && oldFile.active) {
                    if (newFile.xhr.status == 200) {
                       let data = JSON.parse(newFile.response);
                       this.param.auditImgOne = data.data;
                    }
                }
            },
            inputFilter: function (newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // 过滤不是图片后缀的文件
                    if (!/\.(jpeg|jpg|gif|png)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }

                // 创建 blob 字段 用于图片预览
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file);
                    this.upload = true;
                }
            },
            validateBeforeSubmit() {
                let _this = this;
                this.$validator.validateAll().then((result) => {
                    if(result){
                        if(!_this.param.auditImgOne){
                            _this.hasImg = false;
                        }else {
                            util.kAjax(API.CUSTOMERAPPLYIDENTIFY,_this.param,res=>{
                                if(res.status == 1){
                                    util.confirm.success('上传成功')
                                    this.getIdentityInfo();
                                }
                            },function (res) {
                                util.confirm.error(res.data);
                            })
                        }
                    }
                });
            },
            getIdentityInfo() {
              let param = {
                searchUserIdentify:{
                  auditType:2
                }
              }
              util.kAjax(API.CUSTOMERCHECKIDENTIFY,param,res=>{
                if(res.data.length){
                  this.param = res.data[0];
                  if(res.data[0].auditStatus == 1){
                    this.status = '资料已认证通过'
                    this.enableSubmit = false;
                  }else if(res.data[0].auditStatus == 2){
                    this.status = '认证失败，原因：'+(res.data[0].auditFailReason||'资料未通过审核')
                    this.enableSubmit = true;
                  }else if(res.data[0].auditStatus == 3){
                    this.status = '资料认证中，请耐心等待。'
                    this.enableSubmit = false;
                  }
                }
              })
            }
        },
        mounted(){
            this.$store.dispatch('getUserInfo').then(res=>{
                this.options.url = this.options.url+res.data.sessionId;
            });
            this.getIdentityInfo();
        }
    }
</script>



// WEBPACK FOOTER //
// EnterpriseView.vue?5bc22049